var linkRegex = /#_#.?{(.*?)}.?{(.*?)}.?{(.*?)}/g;

function convertAutoSubmitHtmlToSFMarkdown(htmlMessage){
    var text =  "";
    var links = [];
    //var myRegexp = /<a href="javascript:autosubmit\('(.*)'\)">(.*)<\/a>/g;
    //LAZY *
    var myRegexp = /<a href="javascript:autosubmit\('(.*?)'\)">(.*?)<\/a>/g;
    //Getting greddier
    /**
     * Stopped doing .replace(/ class=\\?"Workflow-link\\?"/g,"")
                    .replace(/ class=\\?"wf-summary-confirm\\?"/g,"")
     */

     /**
      * #TODO: ----  Get the extra attributes passed in the Anchor tag
      */
     //var myRegexp = /<a.*?href="javascript:autosubmit\('(.*?)'\).*?">(.*?)<\/a>/g;
    //var matches = myRegexp.exec(htmlMessage);
    var matches = htmlMessage.match(myRegexp);
    //htmlMessage = htmlMessage.replace(myRegexp, `{typeInt}{` + res[1] + `}{` + res[2] + `}`)

    if(matches != null){
        var lastMatchedIndex = 0;
        matches.forEach((element,elementIndex) => {
            var res = myRegexp.exec(htmlMessage);
            var obj = {type : res[1] ,actionValue : res[2] ,actionLabel : res[3] };
            links.push(obj);
            //htmlMessage.slice(res.index , res.index + res[0].length)
            var start = htmlMessage.slice(lastMatchedIndex , res.index);
            var matchLength = res[0].length;
            lastMatchedIndex = res.index + matchLength;
            
            text += start + `#_#{typeInt}{` + res[1] + `}{` + res[2] + `}`;

            if(elementIndex == matches.length -1){
                var end = htmlMessage.slice(res.index + matchLength, htmlMessage.length);
                text += end;     
            } 
                
                // +end
        });
    } else {
        text = htmlMessage;
    }
    
    return text.replace(/<br>/g,"<br/>");
}

function sanitizeMessage(htmlMessage){
    // console.log(htmlMessage)
    var htmlMessage = MDUtil.convertAutoSubmitHtmlToSFMarkdown(htmlMessage);
    // console.log(htmlMessage)
    var text = "";
    var links = [];
    var matches = htmlMessage.match(linkRegex);
    // console.log(matches)

    if(matches != null){
        var lastMatchedIndex = 0;
        matches.forEach((element,elementIndex) => {
            var res = linkRegex.exec(htmlMessage);
            var obj = {type : res[1] ,actionValue : res[2] ,actionLabel : res[3] };
            links.push(obj);
            //htmlMessage.slice(res.index , res.index + res[0].length)
            var start = htmlMessage.slice(lastMatchedIndex , res.index);
            var matchLength = res[0].length;
            lastMatchedIndex = res.index + matchLength;
            
            text += start +
            `<ActionItem 
                actionLabel="${obj.actionLabel}"
                actionValue="${obj.actionValue}"
                actionType="${obj.type}"
                handleSubmit={handleSubmit}
            />
            `
            if(elementIndex == matches.length -1){
                var end = htmlMessage.slice(res.index + matchLength, htmlMessage.length);
                text += end;     
            } 
                
                // +end
        });
    return text.replace(/<br>/g,"<br/>")
    } else {
        return htmlMessage.replace(/<br>/g,"<br/>")
    }
    
}

let MDUtil = {
    convertAutoSubmitHtmlToSFMarkdown: convertAutoSubmitHtmlToSFMarkdown,
    sanitizeMessage : sanitizeMessage,
    linkRegex : linkRegex
}

export default MDUtil;